import { Component } from '@angular/core';

@Component({
  selector: 'app-stores-empty',
  templateUrl: './stores-empty.component.html',
  styleUrls: ['./stores-empty.component.scss']
})
export class StoresEmptyComponent {

}
